import { useTranslation } from 'react-i18next';

const FamilyBuildingAdoptionType = ({ prevStep, handleChange, formData, nextStep, error, step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();
  const unsureOption = "Not sure yet";
  const adoptionTypes = [
    "Domestic infant",
    "International",
    "Foster-to-adopt",
    "Kinship adoption",
    unsureOption,
  ];
  const selectedAdoptionTypes = Array.isArray(formData.AdoptionType)
    ? formData.AdoptionType
    : typeof formData.AdoptionType === "string"
      ? formData.AdoptionType.split(",").map((item) => item.trim()).filter((item) => item !== "")
      : [];

  const handleCheckboxChange = (e) => {
    const { value, checked, name } = e.target;
    let updatedValues;

    if (checked) {
      updatedValues = value === unsureOption
        ? [unsureOption]
        : [...selectedAdoptionTypes.filter((item) => item !== unsureOption), value];
    } else {
      updatedValues = selectedAdoptionTypes.filter((item) => item !== value);
    }

    handleChange({
      target: {
        name,
        value: updatedValues.join(", "),
      },
    });
  };

  return (
    <>
      <div className="step-section">
        <div className="adoption-journey-label">Adoption Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">What type of adoption are you considering?</h3>

        {adoptionTypes.map((type, index) => (
          <div key={type} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
            <input
              type="checkbox"
              className="form-check-input radio-btn win-form-check-input"
              name="AdoptionType"
              id={`adoptionType${index + 1}`}
              value={type}
              checked={selectedAdoptionTypes.includes(type)}
              onChange={handleCheckboxChange}
            />
            <label htmlFor={`adoptionType${index + 1}`} className="multistep-form-radio-checkbox-label">{type}</label>
          </div>
        ))}
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingAdoptionType;
